export const stepList = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14,15,16,17,18,19,20
]
export const keyname=[
    '.C','.#C','.D','.#D','.E','.F','.#F','.G','.#G','.A','.#A','.B','C','#C','D','#D','E','F','#F','G','#G','A','#A','B',"C'","#C'","D'","#D'","E'","F'","#F'","G'","#G'","A'","#A'","B'"
]
// export const stepSpeed = [
//     1,
//     1.5,
//     2,
//     1,
//     1.5,
//     2,
//     0.5,
//     0.75,
//     1,
//     0.5,
//     0.75,
//     1,
//     1,
//     1.5,
//     2,
//     1,
//     1.5,
//     2,
//     0.5,
//     0.75,
//     1,
//     0.5,
//     0.75,
//     1
// ]



// WEBPACK FOOTER //
// ./src/stepList/StepNine.js